import { useState, useCallback } from "react";
import { dashboardBackendUrl } from "../../config/gateway";

interface Process {
  id: number;
  name: string;
  integration: string;
}

interface UseGetProcessReturn {
  dataProcess: Process[] | null;
  loading: boolean;
  error: string | null;
  fetchProcess: () => Promise<void>;
}

const useGetProcess = (): UseGetProcessReturn => {
  const [dataProcess, setDataProcess] = useState<Process[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchProcess = useCallback(async (): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const tokenStorage = localStorage.getItem("token");
      const token = tokenStorage ? tokenStorage.replace(/['"]+/g, "") : null;
      if (!token) {
        throw new Error(
          "Token de acceso no encontrado. Inicia sesión primero."
        );
      }

      const response = await fetch(dashboardBackendUrl.logProcess(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          `Error al obtener Process: ${response.status} - ${response.statusText}`
        );
      }

      if (!Array.isArray(data)) {
        throw new Error(
          "Formato de respuesta inesperado. Se esperaba un array de los Process."
        );
      }

      setDataProcess(data);
    } catch (err) {
      console.error("💥💥💥 --> Error al obtener los Process:", err);
      setError(
        err instanceof Error
          ? err.message
          : "Error desconocido al realizar la solicitud"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  return { dataProcess, loading, error, fetchProcess };
};

export default useGetProcess;
